import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'yn'
})
export class YesNoPipe implements PipeTransform {
  transform(input: boolean): string {
    return input ? 'Yes' : 'No';
  }
}

@Pipe({
  name: 'humantime'
})
export class HumanTimePipe implements PipeTransform {
  transform(date: moment.Moment): string {
    return date.fromNow();
  }
}

@Pipe({
  name: 'timefmt'
})
export class TimeFormatPipe implements PipeTransform {
  transform(date: moment.Moment): string {
    return date.format('your-time-format'); // Replace 'your-time-format' with your desired format
  }
}

@Pipe({
  name: 'geosize'
})
export class GeoSizePipe implements PipeTransform {
  transform(input: number): string {
    if (input === 1) {
      return 'Small';
    } else if (input === 2) {
      return 'Medium';
    } else if (input === 3) {
      return 'Large';
    } else {
      return 'Unknown';
    }
  }
}

@Pipe({
  name: 'camlight'
})
export class CamLightPipe implements PipeTransform {
  transform(input: number): string {
    if (input === 1) {
      return 'Auto';
    } else if (input === 2) {
      return 'Always On';
    } else {
      return 'Off';
    }
  }
}

@Pipe({
  name: 'weatherfilter'
})
export class WeatherFilterPipe implements PipeTransform {
  transform(input: number): string {
    if (input === 0) {
      return 'Minor';
    } else if (input === 1) {
      return 'Moderate';
    } else if (input === 2) {
      return 'Severe';
    } else if (input === 3) {
      return 'Extreme';
    } else {
      return 'Unknown';
    }
  }
}
